import React from "react";

function FileBrowser() {
    return <h1>Welcome to File Browser (in prgress)</h1>;
}

export default FileBrowser;
